import React, { useState } from "react";
import { auth } from "../firebase/firebase-config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "../styles/LoginForm.css";
import LogoSVG from "../hooks/LogoSVG";

const SignUpForm = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleSignUp = async (event) => {
        event.preventDefault();
        try {
            await createUserWithEmailAndPassword(auth, email, password);
            alert("User created successfully!");
            navigate("/home");
        } catch (error) {
            alert("Failed to create user: " + error.message);
        }
    };

    return (
        <div className="mainContainer loginContainer">
            <LogoSVG />
            <form onSubmit={handleSignUp}>
                <h1>Sign Up</h1>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                />
                <button type="submit">Sign Up</button>
            </form>
            <p>
                Have an account? <Link to="/login">Login here</Link>
            </p>
        </div>
    );
};

export default SignUpForm;
